// extracted by mini-css-extract-plugin
export default {"image":"g3-z","loaded":"h3-z"};